import { getLayer } from '../layerService.js';
import { captureNodeState } from '../nodeUtils.js';

export default class ObjectDeleteCommand {
    constructor({ objectUuid, config, pageHaspId, pageUuid }) {
        this.id = crypto.randomUUID();
        this.timestamp = Date.now();
        this.description = 'Delete ' + (config.obj ?? 'object');
        this.category = 'structure';
        this.objectUuid = objectUuid;
        this.affectedUuids = [objectUuid];
        this.pageUuid = pageUuid ?? null;
        // Embed UUID so importObject recreates with the same identity
        this.config = { ...config, _uuid: objectUuid };
        this.pageHaspId = pageHaspId;
    }

    execute() {
        const layer = getLayer();
        if (!layer) return;
        const node = layer.findOne('#' + this.objectUuid);
        if (node) {
            node.destroy();
            layer.batchDraw();
        }
    }

    undo() {
        const layer = getLayer();
        if (!layer) return;
        const page = layer.findPage(this.pageHaspId);
        if (page) layer.switchToPage(page);
        layer.importObject({ ...this.config });
        layer.batchDraw();
    }

    toJSON() {
        return {
            type: 'ObjectDelete',
            id: this.id,
            timestamp: this.timestamp,
            payload: { objectUuid: this.objectUuid, config: this.config, pageHaspId: this.pageHaspId },
        };
    }
}

/**
 * Snapshot config from a live node suitable for ObjectCreateCommand / ObjectDeleteCommand.
 */
export function snapshotObjectConfig(node) {
    const state = captureNodeState(node);
    // Map export keys to importObject's expected keys
    if (state.w !== undefined) { state.width = state.w; }
    if (state.h !== undefined) { state.height = state.h; }
    return state;
}
